import Swiper from 'swiper';

const broadcastSlider = () => {
	const component = document.querySelector('[data-component="broadcast-slider"]');

	if (!component) {
		// console.debug()
		return;
	}

	const sliderBroadcast = new Swiper('[data-component="broadcast-slider"] .swiper', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 30,
        initialSlide: 1,

    });

};

export default broadcastSlider;